import React from "react";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Text, Button, SVG, Modal, SelectBox, Input } from "sunrise-ui";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Menu from "@material-ui/core/Menu";

//---for api-------------
import { useDispatch, useSelector } from "react-redux";
import {
  getAllUserData,
  putUserData,
  getUserAULogs,
  getRank,
} from "../../redux/reducers/users";
import { AppDispatch } from "../../redux/store";
import { getAllProjectData } from "../../redux/reducers/projectReducers";

import EnlargeImage from "./EnlargeImage";
import UserDetailDrawer from "./UserDetailDrawer";
import dateFormat from "../../utilities/dateFormat";
import Loader from "../../utilities/Loader";
import moment from "moment";
import NoDataScreen from "../../utilities/NoDataScreen";
import MultipleSelect from "../../utilities/MultipleSelect/MultipleSelect";
import { CSVLink } from "react-csv";

const useStylesForTable = makeStyles({
  table: {
    minWidth: 650,
  },
});
const useStylesForScrollTable = makeStyles({
  table: {
    minWidth: 650,
    width: "max-content",
  },
});
const useStylesForPopUp = makeStyles({
  customWidth: {
    "& .MuiMenu-list": {
      width: "260px !important",
      border: "1px solid #5F67E0",
      borderRadius: "8px",
    },
  },
  customWidthForViewProjects: {
    "& .MuiMenu-list": {
      maxWidth: "260px !important",
      minWidth: "fit-content",
      border: "1px solid #5F67E0",
      borderRadius: "8px",
    },
  },
});

const AssignUser = ({ userType }: { userType: any }) => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  // to get all existing project record-----
  React.useEffect(() => {
    setLoading(true);
    dispatch(getAllProjectData({ endPoint: "project/get-all-projects" })).then(
      (res) => {
        setLoading(false);
      }
    );
  }, [dispatch]);

  const allProjectData = useSelector(
    (state: any) => state.PROJECT.allProjectData
  );

  let allProjects: [] =
    allProjectData &&
    allProjectData?.map((item: any) => {
      return item?.projectName;
    });
  const [selectBoxData, setSelectBoxData] = React.useState<any>(allProjects);

  // ------------ for table---------------

  React.useEffect(() => {
    setLoading(true);
    dispatch(getAllUserData({ endPoint: "admin/get-user" })).then((res) => {
      setLoading(false);
    });
  }, [dispatch]);
  React.useEffect(() => {
    setLoading(true);
    dispatch(getRank({ endPoint: "general/get-ranks" })).then((res) => {
      setLoading(false);
    });
  }, [dispatch]);
  const allUsersData = useSelector((state: any) => state.USERS.allUserData);
  const ranks = useSelector((state: any) => state.USERS.ranks);
  const [userData, setUserData] = React.useState([]);
  React.useEffect(() => {
    const filteredData: any = [];
    allUsersData &&
      allUsersData?.forEach((item: any) => {
        if (
          item.role.toLowerCase().replace("-", " ") ===
            userType?.toLowerCase().replace("-", " ") &&
          item?.isActive
        ) {
          filteredData.push(item);
        }
      });
    setUserData(filteredData);
    setRows(filteredData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userType, allUsersData]);

  const [rows, setRows] = React.useState<any>(userData);
  const tableClasses = useStylesForTable();
  const scrollTableClasses = useStylesForScrollTable();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [searchVal, setSearchVal] = React.useState([]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filterData = (e: any) => {
    if (e.target.value !== "") {
      setSearchVal(e.target.value);
      const filterTable = rows.filter(
        (item: any) =>
          item?.name?.toLowerCase()?.includes(e.target.value.toLowerCase()) ||
          item?.subContractor?.companyName
            ?.toLowerCase()
            ?.includes(e.target.value.toLowerCase()) ||
          item?.subContractor?.ownerName
            ?.toLowerCase()
            ?.includes(e.target.value.toLowerCase()) ||
          item?.emailId
            ?.toLowerCase()
            ?.includes(e.target.value.toLowerCase()) ||
          item?.mobileNumber?.primaryNumber
            ?.toString()
            ?.toLowerCase()
            ?.includes(e.target.value.toLowerCase())
      );
      setRows(filterTable);
    } else {
      setSearchVal(e.target.value);
      setRows(userData);
    }
  };
  // ---------------for enlarge image modal-------------
  const [modalData, setModalData] = React.useState({
    image: "",
    isOpen: false,
  });

  const handleOpen = (photo: string) => {
    setModalData({ ...modalData, image: photo, isOpen: true });
  };
  //-----For Show User Detail in right Drawer--------
  const [drawerData, setDrawerData] = React.useState({
    details: {},
    isOpen: false,
  });
  const handleShowUserDetail = (detail: any) => {
    setDrawerData({ ...drawerData, details: detail, isOpen: true });
  };
  //-----modal state--------
  const [open, setOpen] = React.useState(false);
  const [modalText, setModalText] = React.useState("");
  const [handleCallData, setHandleCallData] = React.useState({
    type: "",
    userId: "",
    userDetail: {},
    projectsHandled: [],
  });

  const getAllUserLogs = () => {
    dispatch(
      getUserAULogs({
        endPoint: `admin/user-assign-unassign-logs`,
      })
    );
  };

  //------modal handler
  const handleModal = (type: string, userId: string, userDetail: any) => {
    if (
      userType.toLowerCase() !== "planning manager" &&
      userType?.toLowerCase().replace("-", " ") !== "sub contractor"
    ) {
      type === "unassign" ? setOpen(true) : setOpen(false);
      setHandleCallData({
        type: type,
        userId: userId,
        userDetail: userDetail,
        projectsHandled: userDetail?.projectsHandled,
      });
      let project = "";
      allProjectData &&
        allProjectData?.forEach((item: any) => {
          if (item?._id === userDetail?.currentProject?.projectId) {
            project = item?.projectName;
          }
        });
      type === "unassign"
        ? setModalText(
            `Are you sure you want to unassign this ${userDetail?.role} ${
              userType?.toLowerCase().replace("-", " ") !== "sub contractor"
                ? userDetail?.name
                : userDetail?.subContractor?.ownerName
            } from ${project}`
          )
        : setModalText(
            `Are you sure you want to assign this ${userDetail?.role} ${
              userType?.toLowerCase().replace("-", " ") !== "sub contractor"
                ? userDetail?.name
                : userDetail?.subContractor?.ownerName
            } on `
          );
    } else {
      setMultipleValue([]);
      setMultipleOldValue([]);
      setMultipleUnassignValue([]);
      let projectIds: any[] = [];

      userDetail?.multipleCurrentProjects?.forEach((item: any) => {
        allProjectData &&
          allProjectData?.forEach((data: any) => {
            if (data?._id === item?.projectId) {
              projectIds.push(data?.projectName);
            }
          });
      });
      setMultipleOldValue([...projectIds]);

      setHandleCallData({
        type: type,
        userId: userId,
        userDetail: userDetail,
        projectsHandled: userDetail?.projectsHandled,
      });
      //----setting selectBox data for assign more ---
      if (type === "assign more") {
        let projectToKeep: any = allProjects.filter(
          (x: any) => !projectIds.includes(x)
        );
        setSelectBoxData([...projectToKeep]);
      } else {
        setSelectBoxData([...allProjects]);
      }

      type === "unassign"
        ? setModalText(
            `Are you sure you want to unassign this ${userDetail?.role} ${
              userType?.toLowerCase().replace("-", " ") !== "sub contractor"
                ? userDetail?.name
                : userDetail?.subContractor?.ownerName
            } from these `
          )
        : setModalText(
            `Are you sure you want to assign this ${userDetail?.role} ${
              userType?.toLowerCase().replace("-", " ") !== "sub contractor"
                ? userDetail?.name
                : userDetail?.subContractor?.ownerName
            } on these `
          );
    }
  };
  // To get user data
  const getUserData = () => {
    setLoading(true);
    dispatch(getAllUserData({ endPoint: "admin/get-user" })).then((res) => {
      setLoading(false);
    });
  };
  //----modal YES button handler
  const handleCall = () => {
    if (
      userType.toLowerCase() !== "planning manager" &&
      userType?.toLowerCase().replace("-", " ") !== "sub contractor"
    ) {
      if (handleCallData?.type === "unassign") {
        let myObj = {
          currentProject: {},
        };
        dispatch(
          putUserData({
            endPoint: `admin/update-user/${handleCallData?.userId}/unassign/user`,
            data: myObj,
          })
        ).then(() => {
          getAllUserLogs();
          getUserData();
        });
      } else if (handleCallData?.type === "assign") {
        let previousProjects: any[] = handleCallData?.projectsHandled;
        let data = {
          currentProject: {
            projectId: projectId,
            fromDate: fromDate,
            toDate: toDate,
          },
          projectsHandled: [
            {
              projectId: projectId,
              fromDate: fromDate,
              toDate: toDate,
            },
            ...previousProjects,
          ],
        };
        dispatch(
          putUserData({
            endPoint: `admin/update-user/${handleCallData?.userId}/assign/user`,
            data: data,
          })
        ).then(() => {
          getAllUserLogs();
          getUserData();
        });
        handlePopUpCancel();
      }
    } else {
      if (handleCallData?.type === "unassign") {
        let data = {
          multipleCurrentProjects: [...multipleProjectData],
        };
        dispatch(
          putUserData({
            endPoint: `admin/update-user/${handleCallData?.userId}/unassign/subcontractor`,
            data: data,
          })
        ).then(() => {
          getAllUserLogs();
          getUserData();
        });
        handleUnassignPopCancel();
      } else if (
        handleCallData?.type === "assign" ||
        handleCallData?.type === "assign more"
      ) {
        let previousProjects: any[] = handleCallData?.projectsHandled;
        let userDetails: any = handleCallData?.userDetail;
        let oldProjectsHandled = [...multipleProjectData, ...previousProjects];
        oldProjectsHandled = oldProjectsHandled.reduce((a, b) => {
          if (!a.find((d: any) => d.projectId === b.projectId)) {
            a.push(b);
          }
          return a;
        }, []);
        let data = {
          multipleCurrentProjects: [
            ...userDetails?.multipleCurrentProjects,
            ...multipleProjectData,
          ],
          projectsHandled: oldProjectsHandled,
        };
        dispatch(
          putUserData({
            endPoint: `admin/update-user/${handleCallData?.userId}/assign/subcontractor`,
            data: data,
          })
        ).then(() => {
          getAllUserLogs();
          getUserData();
        });
        handlePopUpCancelOfMultiple();
      }
    }

    setOpen(false);
  };
  //---------for assign user popup------
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const classes = useStylesForPopUp();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //-------for multiple unassign popup---
  const [anchorElUnassign, setAnchorElUnassign] =
    React.useState<null | HTMLElement>(null);
  const handleClickUnassign = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElUnassign(event.currentTarget);
  };
  const handleCloseUnassign = () => {
    setAnchorElUnassign(null);
  };

  //  -----on single project-----
  const [projectName, setProjectName] = React.useState("");
  const [projectId, setProjectId] = React.useState("");
  const [ProjectNameErr, setProjectNameErr] = React.useState(false);
  const [fromDate, setFromdate] = React.useState("");
  const [fromDateErr, setFromDateErr] = React.useState(false);
  const [toDate, setToDate] = React.useState("");
  const [toDateErr, setToDateErr] = React.useState(false);
  const toMinDate = new Date().toISOString().split("T")[0];
  //---for multiple unassign----
  const [multipleUnassignValue, setMultipleUnassignValue] = React.useState<any>(
    []
  );
  const [multipleUnassignValueErr, setMultipleUnassignValueErr] =
    React.useState(false);
  // ----for multple project assign-----
  const [multipleValue, setMultipleValue] = React.useState<any>([]);
  const [multipleOldValue, setMultipleOldValue] = React.useState<any>([]);
  const [multipleValueErr, setMultipleValueErr] = React.useState(false);
  const initialDetail =
    multipleValue &&
    multipleValue?.map((item: any) => ({
      mProjectName: item,
      mProjectNameErr: false,
      mFromDate: "",
      mFromDateErr: false,
      mToDate: "",
      mToDateErr: false,
    }));
  const [multipleProjectState, setMultipleProjectState] = React.useState([
    ...initialDetail,
  ]);
  React.useEffect(() => {
    setMultipleProjectState([...initialDetail]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multipleValue]);

  const handleMultipleProjectChange = (e: any, i: number) => {
    let newItems: any[] = [...multipleProjectState];
    if (e.target.name === "mFromDate") {
      newItems[i]["mToDate"] = "";
      newItems[i]["mToDateErr"] = false;
    }
    newItems[i][e.target.name] = e.target.value;
    newItems[i][`${e.target.name}Err`] = false;
    setMultipleProjectState([...newItems]);
  };
  //--for close popup single assign and clear data---
  const handlePopUpCancel = () => {
    setProjectName("");
    setProjectNameErr(false);
    setToDateErr(false);
    setFromDateErr(false);
    setFromdate("");
    setToDate("");
    handleClose();
  };
  //--for close popup multiple assign and clear data---
  const handlePopUpCancelOfMultiple = () => {
    setMultipleValue([]);
    setMultipleOldValue([]);
    setMultipleProjectState([]);
    handleClose();
  };
  //--for close popup multiple unAssign and clear data---
  const handleUnassignPopCancel = () => {
    setMultipleUnassignValue([]);
    handleCloseUnassign();
  };

  // Check if user assigned to date is expired or not
  const checkMultipleExpire = (projects: any) => {
    return projects.some(
      (val: any) =>
        new Date().getTime() <= new Date(val.toDate).getTime() ||
        val?.toDate === null
    );
  };

  // Check if user assigned to date is expired or not
  const checkExpire = (todate: any) => {
    if (todate === null) return true;
    return new Date().getTime() <= new Date(todate).getTime();
  };

  const changeReset = () => {};
  //--------to check err in single project assign-----
  const handlePopUpAssign = () => {
    let goodToGo = true;
    if (projectName === "" || projectName === undefined) {
      goodToGo = false;
      setProjectNameErr(true);
    }
    if (fromDate === "" || fromDate === undefined) {
      setFromDateErr(true);
      goodToGo = false;
    }
    if (toDate === "" || toDate === undefined) {
      setToDateErr(true);
      goodToGo = false;
    }
    if (goodToGo === true) {
      setOpen(true);
      handleClose();
      //  --went to modal yes button handler--
    }
  };
  //----to check err in multiple project assign
  const [multipleProjectData, setMultipleProjectData] = React.useState<any>([]);
  const handleMultipleProjectPopUpAssign = () => {
    if (multipleProjectState?.length > 0) {
      let goodToGo = true;
      let newItems: any[] = [...multipleProjectState];
      newItems?.forEach((item: any, index: number) => {
        if (item?.mFromDate === "") {
          goodToGo = false;
          newItems[index].mFromDateErr = true;
        }
        if (item?.mToDate === "") {
          goodToGo = false;
          newItems[index].mToDateErr = true;
        }
      });
      setMultipleProjectState([...newItems]);
      if (goodToGo === true) {
        let myProjectArray: any[] = [];
        multipleProjectState?.forEach((item: any, index: number) => {
          let projectID = "";
          allProjectData &&
            allProjectData?.forEach((data: any) => {
              if (data?.projectName === item?.mProjectName) {
                projectID = data?._id;
              }
            });

          let myObj = {
            projectId: projectID,
            fromDate: item?.mFromDate,
            toDate: item?.mToDate,
          };
          myProjectArray.push(myObj);
        });
        setMultipleProjectData([...myProjectArray]);

        setOpen(true);
        handleClose();
        //  --went to modal yes button handler--
      }
    } else {
      setMultipleValueErr(true);
    }
  };
  //--handle popup unassign multiple and check empty data-------
  const handleMultipleProjectPopUpUnAssign = () => {
    if (multipleUnassignValue?.length < 1) {
      setMultipleUnassignValueErr(true);
    } else {
      let myProjectArray: any[] = [];
      multipleOldValue?.forEach((item: any) => {
        allProjectData &&
          allProjectData?.forEach((data: any) => {
            if (data?.projectName === item) {
              myProjectArray.push(data);
            }
          });
      });
      let selectedprojectId: any[] = [];
      myProjectArray?.forEach((data: any) => {
        multipleUnassignValue?.forEach((item: any) => {
          if (data?.projectName === item) {
            selectedprojectId.push(data?._id);
          }
        });
      });
      let userDetails: any = handleCallData?.userDetail;
      let projectToKeep = userDetails?.multipleCurrentProjects.filter(
        (x: any) => !selectedprojectId.includes(x?.projectId)
      );

      setMultipleProjectData([...projectToKeep]);

      setOpen(true);
      handleCloseUnassign();
      //  --went to modal yes button handler--
    }
  };
  //----to view assigned multiple projects
  const [oldProjectToView, setOldProjectToView] = React.useState<any>([]);
  const handleView = (userData: any) => {
    let projectIds: any[] = [];
    userData?.multipleCurrentProjects?.forEach((item: any) => {
      allProjectData &&
        allProjectData?.forEach((data: any) => {
          if (
            data?._id === item?.projectId &&
            new Date().getTime() <= new Date(item?.toDate).getTime()
          ) {
            projectIds.push(data?.projectName);
          }
        });
    });
    setOldProjectToView([...projectIds]);
  };
  //-------for view assigned project popup---
  const [anchorElView, setAnchorElView] =
    React.useState<null | HTMLElement>(null);
  const handleClickView = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElView(event.currentTarget);
  };
  const handleCloseView = () => {
    setAnchorElView(null);
  };

  //----for excel download
  const [dataToDownload, setDataToDownload] = React.useState<any>([]);
  React.useEffect(() => {
    if (rows && rows?.length > 0) {
      let myArray: any = [];
      rows?.forEach((item: any) => {
        if (
          item?.role?.toLowerCase()?.replace("-", " ") !== "sub contractor" &&
          item?.role?.toLowerCase()?.replace("-", " ") !== "planning manager"
        ) {
          let project = "";
          allProjectData &&
            allProjectData?.forEach((data: any) => {
              if (data?._id === item?.currentProject?.projectId) {
                project = data?.projectName;
              }
            });
          let myObj = {
            name: item?.name,
            email: item?.emailId,
            role: item?.role,
            primary_mobile: item?.mobileNumber?.primaryNumber,
            alternate_mobile: item?.mobileNumber?.secondaryNumber,
            user_image: item?.userImage,
            current_project: project,
          };
          myArray.push(myObj);
        } else if (
          item?.role?.toLowerCase().replace("-", " ") === "sub contractor"
        ) {
          let projectIds: any[] = [];
          item?.multipleCurrentProjects?.forEach((x: any) => {
            allProjectData &&
              allProjectData?.forEach((data: any) => {
                if (data?._id === x?.projectId) {
                  projectIds.push(data?.projectName);
                }
              });
          });
          let myObj = {
            representative_name: item?.subContractor?.ownerName,
            role: item?.role,
            type: item?.subContractor?.type,
            primary_mobile: item?.mobileNumber?.primaryNumber,
            alternate_mobile: item?.mobileNumber?.secondaryNumber,
            aadhaar_image: item?.aadhar?.image,
            pan_image: item?.pan?.image,
            current_projects: projectIds?.join(", "),
          };
          myArray.push(myObj);
        } else if (
          item?.role?.toLowerCase()?.replace("-", " ") === "planning manager"
        ) {
          let projectIds: any[] = [];
          item?.multipleCurrentProjects?.forEach((x: any) => {
            allProjectData &&
              allProjectData?.forEach((data: any) => {
                if (data?._id === x?.projectId) {
                  projectIds.push(data?.projectName);
                }
              });
          });
          let myObj = {
            name: item?.name,
            email: item?.emailId,
            role: item?.role,
            primary_mobile: item?.mobileNumber?.primaryNumber,
            alternate_mobile: item?.mobileNumber?.secondaryNumber,
            user_image: item?.userImage,
            current_projects: projectIds?.join(", "),
          };
          myArray.push(myObj);
        }
      });
      setDataToDownload(myArray);
    }
  }, [rows, allProjectData]);

  return (
    <>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <Grid container className="second_tab_content assign_users_wrapper">
          <Grid item xs={12}>
            <Grid container className="d-flex v-center sb">
              <Grid></Grid>
              {allUsersData?.length > 0 && (
                <Grid className="d-flex sb v-center relative">
                  <div className="searchIcon_box absolute">
                    <SVG type={"searchIcon"} />
                  </div>
                  <div className="search_box mr-1">
                    <input
                      type="search"
                      id="tableSearch"
                      name="tableSearch"
                      placeholder="Search"
                      value={searchVal}
                      onChange={filterData}
                    />
                  </div>
                  <div className="mr-1 pointer">
                    <CSVLink data={dataToDownload} filename="UserDetail">
                      <SVG type={"download"} isActive={true} />
                    </CSVLink>
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} className="candidate_table">
            <Grid className="table_container">
              {allUsersData?.length > 0 ? (
                <Paper className="overfl">
                  <TableContainer style={{maxHeight:440}}>
                  <Table
                    className={
                      userType?.toLowerCase() === "engineer" ||
                      userType?.toLowerCase() === "project manager" ||
                      userType?.toLowerCase() === "planning manager" ||
                      userType?.toLowerCase().replace("-", " ") ===
                        "sub contractor"
                        ? scrollTableClasses.table
                        : tableClasses.table
                    }
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ minWidth: 170 }}>
                          {userType !== "" ? "" : "User"}
                          {userType?.toLowerCase().replace("-", " ") ===
                          "sub contractor"
                            ? "Representative Name"
                            : `${userType} Name`}
                        </TableCell>
                        {userType?.toLowerCase().replace("-", " ") ===
                        "sub contractor" ? (
                          <TableCell
                            className="f14 fw500"
                            align="left"
                            style={{ minWidth: 150 }}
                          >
                            Sub-Contractor Company Name
                          </TableCell>
                        ) : (
                          <></>
                        )}
                        {userType?.toLowerCase() === "engineer" ? (
                          <TableCell
                            className="f14 fw500"
                            align="left"
                            style={{ minWidth: 150 }}
                          >
                            Project Level Rank
                          </TableCell>
                        ) : (
                          <></>
                        )}
                        {userType?.toLowerCase() === "engineer" ? (
                          <TableCell
                            className="f14 fw500"
                            align="left"
                            style={{ minWidth: 150 }}
                          >
                            Global Rank
                          </TableCell>
                        ) : (
                          <></>
                        )}
                        {userType?.toLowerCase() === "operator" ||
                        userType?.toLowerCase() === "staff" ? (
                          <TableCell
                            className="f14 fw500"
                            align="left"
                            style={{ minWidth: 150 }}
                          >
                            Type of {userType && userType}
                          </TableCell>
                        ) : (
                          <></>
                        )}
                        <TableCell
                          className="f14 fw500"
                          align="left"
                          style={{ minWidth: 120 }}
                        >
                          Phone&nbsp;Number
                        </TableCell>
                        <TableCell
                          className="f14 fw500"
                          align="left"
                          style={{ minWidth: 120 }}
                        >
                          Email Id
                        </TableCell>
                        {userType?.toLowerCase() !== "operator" &&
                        userType?.toLowerCase() !== "staff" &&
                        userType?.toLowerCase()?.replace("-", " ") !==
                          "sub contractor" ? (
                          <TableCell
                            className="f14 fw500"
                            align="left"
                            style={{ minWidth: 150 }}
                          >
                            Joining&nbsp;Date
                          </TableCell>
                        ) : (
                          <></>
                        )}
                        <TableCell
                          className="f14 fw500"
                          align="left"
                          style={{ minWidth: 150 }}
                        >
                          Last Updated Date
                        </TableCell>
                        <TableCell
                          className="f14 fw500"
                          align="left"
                          style={{ minWidth: 150 }}
                        >
                          Availability
                        </TableCell>
                        <TableCell
                          className="f14 fw500"
                          align="left"
                          style={{ minWidth: 150 }}
                        >
                          Photo
                        </TableCell>
                        <TableCell
                          className="f14 fw500"
                          align="left"
                          style={{ minWidth: 150 }}
                        >
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {rows?.length > 0 ? (
                      <TableBody>
                        {rows &&
                          rows
                            ?.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row: any, index: number) => (
                              <TableRow key={index}>
                                <TableCell component="th" scope="row">
                                  <Text
                                    type="link"
                                    fonts="normal"
                                    className="mb0 mt0 capitalize"
                                    onTextClick={() => {
                                      handleShowUserDetail(row);
                                    }}
                                  >
                                    {userType
                                      ?.toLowerCase()
                                      .replace("-", " ") === "sub contractor"
                                      ? row?.subContractor?.ownerName
                                      : row?.name}
                                  </Text>
                                </TableCell>
                                {userType?.toLowerCase().replace("-", " ") ===
                                "sub contractor" ? (
                                  <TableCell
                                    className="f14 fw400 capitalize"
                                    align="left"
                                  >
                                    {row?.subContractor?.companyName}
                                  </TableCell>
                                ) : (
                                  <></>
                                )}

                                {userType?.toLowerCase() === "engineer" ? (
                                  <TableCell className="f14 fw400" align="left">
                                    <>
                                      {/*Project level rank */}
                                      {console.log(row)}
                                      {row?.currentProject &&
                                      ranks?.projectranks
                                        ? ranks?.projectranks[
                                            `${row?.currentProject?.projectId}`
                                          ]?.filter(
                                            (item: any) =>
                                              item?.empId === row?.empId
                                          )[0]?.rank
                                          ? ranks?.projectranks[
                                              row?.currentProject?.projectId
                                            ]?.filter(
                                              (item: any) =>
                                                item?.empId === row?.empId
                                            )[0]?.rank
                                          : "-"
                                        : "-"}
                                    </>
                                  </TableCell>
                                ) : (
                                  <></>
                                )}
                                {userType?.toLowerCase() === "engineer" ? (
                                  <TableCell className="f14 fw400" align="left">
                                    <>
                                      {/*Global Rank */}
                                      {ranks?.globalranks?.filter(
                                        (item: any) => item.empId === row.empId
                                      )[0]?.rank
                                        ? ranks?.globalranks?.filter(
                                            (item: any) =>
                                              item.empId === row.empId
                                          )[0]?.rank
                                        : "-"}
                                      {console.log("ROW:", row)}
                                    </>
                                  </TableCell>
                                ) : (
                                  <></>
                                )}
                                {userType?.toLowerCase() === "operator" ||
                                userType?.toLowerCase() === "staff" ? (
                                  <TableCell
                                    className="f14 fw400 capitalize"
                                    align="left"
                                  >
                                    {row?.designation}
                                  </TableCell>
                                ) : (
                                  <></>
                                )}
                                <TableCell className="f14 fw400" align="left">
                                  {row?.mobileNumber?.primaryNumber}
                                </TableCell>
                                <TableCell className="f14 fw400" align="left">
                                  {row?.emailId}
                                </TableCell>
                                {userType?.toLowerCase() !== "operator" &&
                                userType?.toLowerCase() !== "staff" &&
                                userType?.toLowerCase()?.replace("-", " ") !==
                                  "sub contractor" ? (
                                  <TableCell className="f14 fw400" align="left">
                                    {dateFormat(
                                      row?.joiningDate?.split("T")[0]
                                    )}
                                  </TableCell>
                                ) : (
                                  <></>
                                )}
                                <TableCell className="f14 fw400" align="left">
                                  {moment(row?.updatedAt).format(
                                    "DD,MMM,YYYY, h:mm A"
                                  )}
                                </TableCell>

                                <TableCell className="f14 fw400" align="left">
                                  {userType.toLowerCase() !==
                                    "planning manager" &&
                                  userType?.toLowerCase().replace("-", " ") !==
                                    "sub contractor" ? (
                                    <div>
                                      {row?.currentProject &&
                                      row.currentProject?.projectId &&
                                      allProjectData &&
                                      allProjectData.filter(
                                        (item: any) =>
                                          item._id ===
                                          row.currentProject?.projectId
                                      )[0] &&
                                      checkExpire(
                                        row.currentProject?.toDate
                                      ) ? (
                                        <span className="text--success capitalize fw500">
                                          Assigned&nbsp;to
                                          <br />
                                          {allProjectData &&
                                            allProjectData?.map((item: any) => {
                                              let project = "";
                                              if (
                                                item?._id ===
                                                row?.currentProject?.projectId
                                              ) {
                                                project = item?.projectName;
                                              }
                                              return project;
                                            })}
                                        </span>
                                      ) : (
                                        <span className="text--danger fw500">
                                          Not assigned to any
                                          <br /> project yet.
                                        </span>
                                      )}
                                    </div>
                                  ) : (
                                    <div>
                                      {row?.multipleCurrentProjects &&
                                      row?.multipleCurrentProjects?.length >
                                        0 &&
                                      checkMultipleExpire(
                                        row?.multipleCurrentProjects
                                      ) ? (
                                        <div className="d-flex">
                                          <div
                                            className="mr-1 pointer"
                                            onClick={(e: any) => {
                                              handleView(row);
                                              handleClickView(e);
                                            }}
                                          >
                                            <span className="text--success capitalize fw500">
                                              View Assigned
                                              <br />
                                              Projects
                                            </span>
                                          </div>
                                          <Text
                                            fonts="normal"
                                            onTextClick={(e: any) => {
                                              handleClick(e);
                                              handleModal(
                                                "assign more",
                                                row?._id,
                                                row
                                              );
                                            }}
                                            type="link"
                                            fontSize={14}
                                            className="mb1 mt0 fw500"
                                          >
                                            Assign More
                                          </Text>
                                        </div>
                                      ) : (
                                        <span className="text--danger fw500">
                                          Not assigned to any
                                          <br /> project yet.
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </TableCell>
                                <TableCell className="f14 fw400" align="left">
                                  {
                                    <img
                                      src={
                                        userType
                                          ?.toLowerCase()
                                          .replace("-", " ") ===
                                        "sub contractor"
                                          ? row?.pan?.image
                                          : row.userImage
                                      }
                                      alt="..."
                                      className="candidate_photo pointer"
                                      onClick={() => {
                                        handleOpen(
                                          userType
                                            ?.toLowerCase()
                                            .replace("-", " ") ===
                                            "sub contractor"
                                            ? row?.pan?.image
                                            : row.userImage
                                        );
                                      }}
                                    />
                                  }
                                </TableCell>
                                <TableCell className="f14 fw400" align="left">
                                  {userType.toLowerCase() !==
                                    "planning manager" &&
                                  userType?.toLowerCase().replace("-", " ") !==
                                    "sub contractor" ? (
                                    <div className="action_buttons_box d-flex v-center">
                                      {row?.currentProject &&
                                      row?.currentProject?.projectId &&
                                      allProjectData &&
                                      allProjectData.filter(
                                        (item: any) =>
                                          item._id ===
                                          row.currentProject?.projectId
                                      )[0] &&
                                      checkExpire(
                                        row.currentProject?.toDate
                                      ) ? (
                                        <Button
                                          type="button"
                                          size="small"
                                          isRounded={true}
                                          category="warning"
                                          onClick={() => {
                                            handleModal(
                                              "unassign",
                                              row?._id,
                                              row
                                            );
                                          }}
                                          className="f14"
                                        >
                                          Unassign
                                        </Button>
                                      ) : (
                                        <Button
                                          type="button"
                                          size="small"
                                          isRounded={true}
                                          category="success"
                                          onClick={(e: any) => {
                                            handleClick(e);
                                            handleModal(
                                              "assign",
                                              row?._id,
                                              row
                                            );
                                          }}
                                          className="mr-1 f14"
                                        >
                                          Assign
                                        </Button>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="action_buttons_box d-flex v-center">
                                      {row?.multipleCurrentProjects &&
                                      row?.multipleCurrentProjects?.length >
                                        0 &&
                                      checkMultipleExpire(
                                        row?.multipleCurrentProjects
                                      ) ? (
                                        <Button
                                          type="button"
                                          size="small"
                                          isRounded={true}
                                          category="warning"
                                          onClick={(e: any) => {
                                            handleClickUnassign(e);
                                            handleModal(
                                              "unassign",
                                              row?._id,
                                              row
                                            );
                                          }}
                                          className="f14"
                                        >
                                          Unassign
                                        </Button>
                                      ) : (
                                        <Button
                                          type="button"
                                          size="small"
                                          isRounded={true}
                                          category="success"
                                          onClick={(e: any) => {
                                            handleClick(e);
                                            handleModal(
                                              "assign",
                                              row?._id,
                                              row
                                            );
                                          }}
                                          className="mr-1 f14"
                                        >
                                          Assign
                                        </Button>
                                      )}
                                    </div>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                      </TableBody>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={13} align="center">
                          No Data Found
                        </TableCell>
                      </TableRow>
                    )}
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
                </Paper>
              ) : (
                userType !== "" && (
                  <NoDataScreen text="The are no data available to assign or unassign." />
                )
              )}
            </Grid>
            {/* -------modal---- */}
            <Grid item xs={12}>
              <Modal
                image="modalImage"
                call={() => {
                  handleCall();
                }}
                reset={() => {
                  setOpen(false);
                }}
                openModal={open}
                title={`${modalText} ${
                  handleCallData?.type === "assign" ? projectName || "" : ""
                } project?`}
                showImageModal={false}
              />
            </Grid>
            {/* ---------------Enlarge Image Modal---------- */}
            <EnlargeImage modalData={modalData} />

            {/* --------------Drawer modal-------------------- */}
            <UserDetailDrawer drawerData={drawerData} />

            {/* ------------for assign user popup------ */}
            <Grid item xs={12}>
              <Menu
                id="popup-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className={classes.customWidth}
              >
                {userType.toLowerCase() !== "planning manager" &&
                userType?.toLowerCase().replace("-", " ") !==
                  "sub contractor" ? (
                  <Grid container className="p1">
                    <Grid item xs={12}>
                      <Grid className="mb">
                        <Text
                          type="normal"
                          fonts="normal"
                          fontSize={16}
                          className="mb0 mt0"
                        >
                          <span className="fw500">Choose Project*</span>
                        </Text>
                        <SelectBox
                          data={[...allProjects]}
                          defaultVal={projectName}
                          placeHolder="Choose Project"
                          resetVal={projectName === "" ? true : false}
                          changeReset={changeReset}
                          onChange={(e) => {
                            let target = { ...e };
                            setProjectName(target.target.value);
                            setProjectNameErr(false);
                            const index = allProjects
                              ?.map((item: any) => item)
                              .indexOf(target.target.value);
                            setProjectId(
                              allProjectData && allProjectData[index]?._id
                            );
                          }}
                          borderColor={ProjectNameErr ? "danger" : "primary"}
                        />
                      </Grid>
                    </Grid>
                    {/* -------From date field------ */}
                    <Grid item xs={12}>
                      <Text
                        type="normal"
                        fonts="normal"
                        fontSize={16}
                        className="mb mt0"
                      >
                        <span className="fw500">From*</span>
                      </Text>
                      <Input
                        color={fromDateErr ? "danger" : "primary"}
                        fonts="normal"
                        placeholder="Enter Here"
                        value={fromDate}
                        type="date"
                        onChange={(e) => {
                          setFromdate(e.target.value);
                          setToDate("");
                          setFromDateErr(false);
                          setToDateErr(false);
                        }}
                      />
                    </Grid>
                    {/* -------To date field------ */}
                    <Grid item xs={12}>
                      <Text
                        type="normal"
                        fonts="normal"
                        fontSize={16}
                        className="mb mt1"
                      >
                        <span className="fw500">To*</span>
                      </Text>
                      <Input
                        color={toDateErr ? "danger" : "primary"}
                        fonts="normal"
                        placeholder="Enter Here"
                        value={toDate}
                        type="date"
                        min={toMinDate}
                        onChange={(e) => {
                          setToDate(e.target.value);
                          setToDateErr(false);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid className="d-flex mt1">
                        <Button
                          type="button"
                          size="medium"
                          isRounded={true}
                          category="border-only"
                          onClick={() => {
                            handlePopUpCancel();
                          }}
                          className="f14 mr-1"
                        >
                          Cancel
                        </Button>
                        <Button
                          type="button"
                          size="medium"
                          isRounded={true}
                          category="primary"
                          onClick={() => {
                            handlePopUpAssign();
                          }}
                          className="f14"
                        >
                          Assign
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container className="p1">
                    <Grid item xs={12}>
                      <Grid>
                        <Text
                          type="normal"
                          fonts="normal"
                          fontSize={16}
                          className="mb mt0"
                        >
                          <span className="fw500">Choose Project/s*</span>
                        </Text>

                        <MultipleSelect
                          selectData={{
                            data: selectBoxData,
                            name: "multiSelect",
                            disabled: false,
                            placeHolder: "Choose Projects",
                            borderColor: !multipleValueErr
                              ? "primary"
                              : "danger",
                            defaultValue: multipleValue,
                            oldValue: multipleValue,
                            onChange: (e: any) => {
                              setMultipleValue(e.target.value);
                              setMultipleValueErr(false);
                            },
                          }}
                        ></MultipleSelect>
                      </Grid>
                    </Grid>
                    {multipleProjectState.length > 0 &&
                      multipleProjectState.map((item, index) => (
                        <Grid item xs={12}>
                          {/* -------From date field------ */}
                          <Grid item xs={12}>
                            <Text
                              type="normal"
                              fonts="normal"
                              fontSize={16}
                              className="mb mt1"
                            >
                              <span className="fw500">Project Name: </span>
                              <span className="fw400 capitalize">
                                {item?.mProjectName}
                              </span>
                            </Text>
                            <Text
                              type="normal"
                              fonts="normal"
                              fontSize={16}
                              className="mb mt0"
                            >
                              <span className="fw500">From*</span>
                            </Text>
                            <Input
                              color={
                                multipleProjectState[index]?.mFromDateErr
                                  ? "danger"
                                  : "primary"
                              }
                              fonts="normal"
                              placeholder="Enter Here"
                              name="mFromDate"
                              value={multipleProjectState[index]?.mFromDate}
                              type="date"
                              onChange={(e) => {
                                handleMultipleProjectChange(e, index);
                              }}
                            />
                          </Grid>
                          {/* -------To date field------ */}
                          <Grid item xs={12}>
                            <Text
                              type="normal"
                              fonts="normal"
                              fontSize={16}
                              className="mb mt1"
                            >
                              <span className="fw500">To*</span>
                            </Text>
                            <Input
                              color={
                                multipleProjectState[index]?.mToDateErr
                                  ? "danger"
                                  : "primary"
                              }
                              fonts="normal"
                              placeholder="Enter Here"
                              value={multipleProjectState[index]?.mToDate}
                              type="date"
                              min={toMinDate} //multipleProjectState[index]?.mFromDate
                              name="mToDate"
                              onChange={(e) => {
                                handleMultipleProjectChange(e, index);
                              }}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    <Grid item xs={12}>
                      <Grid className="d-flex mt1">
                        <Button
                          type="button"
                          size="medium"
                          isRounded={true}
                          category="border-only"
                          onClick={() => {
                            handlePopUpCancelOfMultiple();
                          }}
                          className="f14 mr-1"
                        >
                          Cancel
                        </Button>
                        <Button
                          type="button"
                          size="medium"
                          isRounded={true}
                          category="primary"
                          onClick={() => {
                            handleMultipleProjectPopUpAssign();
                          }}
                          className="f14"
                        >
                          Assign
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Menu>
            </Grid>
            {/* -----------for multiple unassign------------ */}
            <Menu
              id="UnassignPopup-menu"
              anchorEl={anchorElUnassign}
              keepMounted
              open={Boolean(anchorElUnassign)}
              onClose={handleCloseUnassign}
              className={classes.customWidth}
            >
              <Grid container className="p1">
                <Grid item xs={12}>
                  <Grid>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb mt0"
                    >
                      <span className="fw500">Choose Project/s*</span>
                    </Text>

                    <MultipleSelect
                      selectData={{
                        data: multipleOldValue,
                        name: "multiSelectUnassign",
                        disabled: false,
                        placeHolder: "Choose Projects",
                        borderColor: !multipleUnassignValueErr
                          ? "primary"
                          : "danger",
                        defaultValue: multipleUnassignValue,
                        oldValue: multipleUnassignValue,
                        onChange: (e: any) => {
                          setMultipleUnassignValue(e.target.value);
                          setMultipleUnassignValueErr(false);
                        },
                      }}
                    ></MultipleSelect>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid className="d-flex mt1">
                    <Button
                      type="button"
                      size="medium"
                      isRounded={true}
                      category="border-only"
                      onClick={() => {
                        handleUnassignPopCancel();
                      }}
                      className="f14 mr-1"
                    >
                      Cancel
                    </Button>
                    <Button
                      type="button"
                      size="medium"
                      isRounded={true}
                      category="primary"
                      onClick={() => {
                        handleMultipleProjectPopUpUnAssign();
                      }}
                      className="f14"
                    >
                      Unassign
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Menu>
            {/* -----------to View assigned projects name------------ */}
            <Menu
              id="ViewOldProjectPopup-menu"
              anchorEl={anchorElView}
              keepMounted
              open={Boolean(anchorElView)}
              onClose={handleCloseView}
              className={classes.customWidthForViewProjects}
            >
              <Grid container className="pr pl">
                <Grid item xs={12}>
                  <Grid>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb mt0"
                    >
                      <span className="fw500">
                        Assigned{" "}
                        {oldProjectToView && oldProjectToView?.length > 1
                          ? "Projects"
                          : "Project"}
                      </span>
                    </Text>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  {oldProjectToView &&
                    oldProjectToView?.map((item: any) => {
                      return (
                        <Text
                          type="normal"
                          fonts="normal"
                          fontSize={14}
                          className="mb mt0"
                        >
                          <span className="fw400">{item || ""}</span>
                        </Text>
                      );
                    })}
                </Grid>
              </Grid>
            </Menu>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AssignUser;
